import { render, staticRenderFns } from "./CookiesComponent.vue?vue&type=template&id=aa70bce8"
import script from "./CookiesComponent.vue?vue&type=script&lang=js"
export * from "./CookiesComponent.vue?vue&type=script&lang=js"
import style0 from "./CookiesComponent.vue?vue&type=style&index=0&id=aa70bce8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports